import { ClassicChat } from '@vp/care-classic-chat';
import {
    BoundedContent,
    Box,
    Button,
    Column,
    FlexBox,
    GridContainer,
    H2,
    Icon,
    Link,
    Row,
    Spinner,
} from '@vp/swan';
import { isChatAnywhereEnabled } from '@99designs/care';
import { __, __url } from '@99designs/i18n';
import { sendChatNowTrackingEvent, sendNavigationEvent, usePage } from '@99designs/tracking';

const supportAnalyticsData = {
    label: 'Content:Help Center Section',
    eventDetail: '/design;/graphic-design;Help Center Section;VisitHelpCenter-CTA',
    navigationDetail: 'VisitHelpCenter-CTA',
    category: 'Navigation Clicked',
};

export function Support({ locale }: { locale: string }) {
    const { pageData } = usePage();

    return (
        <Box data-testid="support">
            <Box backgroundColor="help" paddingTop={8} paddingBottom={8}>
                <BoundedContent textAlign={'center'}>
                    <GridContainer>
                        <Row>
                            <Column offset={3} span={6} offsetLg={3} spanLg={6}>
                                <H2 fontSize="x2large">{__('Still unsure?')}</H2>
                                <Box marginBottom="between-subsections">
                                    {__(
                                        'Browse our Help Centre or chat with one of our Customer Care Specialists who will be available anytime to help you get a great design.'
                                    )}
                                </Box>
                                <FlexBox id="online" justifyContent="center">
                                    <Button
                                        marginRight={4}
                                        id="onlineBtn"
                                        skin="secondary"
                                        onClick={() =>
                                            sendNavigationEvent({
                                                ...supportAnalyticsData,
                                                ...pageData,
                                            })
                                        }
                                        iconPosition="left"
                                        data-section={supportAnalyticsData.label}
                                        data-position={0}
                                        data-translation={supportAnalyticsData.navigationDetail}
                                        render={(props) => (
                                            <Link
                                                to={__url('/customer-care/help-center/')}
                                                className={props.className}
                                            >
                                                {props.children}
                                            </Link>
                                        )}
                                    >
                                        <Icon iconType="helpQuery" />
                                        {__('Visit our help center')}
                                    </Button>
                                    <Button
                                        id="onlineBtn"
                                        skin="secondary"
                                        iconPosition="left"
                                        onClick={() =>
                                            sendChatNowTrackingEvent({ locale, ...pageData })
                                        }
                                    >
                                        <Icon iconType="liveChat" />
                                        {__('Chat with us')}
                                    </Button>

                                    {typeof window !== 'undefined' &&
                                        !isChatAnywhereEnabled(locale) && (
                                            <Spinner
                                                id="loader"
                                                accessibleText={__('Loading…')}
                                                size="standard"
                                            />
                                        )}
                                </FlexBox>
                            </Column>
                        </Row>
                    </GridContainer>
                </BoundedContent>
                {typeof window !== 'undefined' && !isChatAnywhereEnabled(locale) && (
                    <ClassicChat
                        startChatElement="onlineBtn"
                        onlineElementIds={['online']}
                        loader="loader"
                        locale={locale}
                        tenant="vistaprint"
                        requestor="classicChatPackage"
                    />
                )}
            </Box>
        </Box>
    );
}
